import { cache } from "react";

function getCacheImpl() {
  const value: { locale?: string } = { locale: undefined };
  return value;
}

const getCache = cache(getCacheImpl);

export function getCachedRequestLocale() {
  return getCache().locale;
}

export function setRequestLocale(locale: string) {
  getCache().locale = locale;
}
